import { Component, OnInit,ViewChild, AfterViewInit,ElementRef } from '@angular/core';
import { Subscription} from 'rxjs';
import { ThemeService } from "../../theme/theme.service";
import { AccountService } from '../../services/account.service';
import { AccountStatusService } from '../../services/accountstatus.service';
import { EntityService } from '../../services/entity.service';
import { AssetMapService } from '../../services/assetmap.service';
import { LogoService } from '../../services/logo.service';
import { addEntityProperty } from '../../services/util.service';
import { ActivatedRoute, Router, NavigationEnd} from '@angular/router';

@Component({
  selector: 'app-architecture-print',
  templateUrl: './architecture-print.component.html',
  styleUrls: ['./architecture-print.component.scss']
})
export class ArchitecturePrintComponent implements OnInit, AfterViewInit {

  themeSub$: Subscription;
  themes: any;
  themeMode = "light";

  @ViewChild('usecase',{ read: ElementRef }) useCase;
  useCaseHeight = 1000;

  @ViewChild('assetmap',{ read: ElementRef }) assetMapView;
  assetMapHeight = 1000;

  @ViewChild('slview') slView;
  viewHeight = 'auto';
  viewHeightScale = 1;

  @ViewChild('slhealthview') slHealthView;
  healthViewHeight = 'auto';
  healthViewHeightScale = 1;
  
  private accountsStatusData$: Subscription;
  private accountsData$: Subscription;
  private entitiesData$: Subscription;
  private assetMapsData$: Subscription;
    
  accountsData:any;
  accountsStatusData:any;
  entitiesData:any;
  assetMapData:any;

  sAccount=null;
  sVersion=null;
  isData=false;
  isLoading=true;
  loading = 0;

  private logosData$: Subscription;
  logosData:any;
  useNewLayout = false;
  private stackColors$: Subscription;
  stackColors: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
    public accountService: AccountService,
    public acountsStatusService: AccountStatusService,
    public assetMapService: AssetMapService,
    public entityService: EntityService, 
    public logoService: LogoService,
  ) { 
    
  }

  ngAfterViewInit() {    
    this.setHeightAndPrint();
  }

  setHeightAndPrint() {
    if (this.useCase && this.slView && this.slHealthView && this.assetMapView) {
      // Adjust the heights for the scaling - the div still has the 100% height so need
      // to calculate what it is after the scaling and asjust
      setTimeout(() => {
        const stageViewElement = document.getElementsByClassName('stage-view')[0];
        const healthViewElement = document.getElementsByClassName("stage-healthview")[0];
        const useCaseScale = this.useNewLayout ? 0.72 : 0.73;
        this.useCaseHeight = this.useCase.nativeElement.offsetHeight * useCaseScale;
        this.viewHeightScale = this.calculateScale(stageViewElement.scrollHeight);
        this.viewHeight = (stageViewElement.scrollHeight * this.viewHeightScale + 10) + 'px';
        this.healthViewHeightScale = this.calculateScale(healthViewElement.scrollHeight);
        this.healthViewHeight = (healthViewElement.scrollHeight * this.healthViewHeightScale + 10) + 'px';
        const assetMapScale = this.useNewLayout ? 0.75 : 0.92;
        this.assetMapHeight = this.assetMapView.nativeElement.offsetHeight * assetMapScale;
      }, 500);

      setTimeout(() => {
        // Open the print dialog and close page once it has closed
        window.print();
        setTimeout(window.close, 0);
      }, 1000);
    } else {
      setTimeout(() => {
        this.setHeightAndPrint();
      }, 1000);
    }
  }

  calculateScale(scrollHeight: number) {
    const defaultPageHeight = 980;
    const defaultWidthScale = this.useNewLayout ? 0.7 : 0.79;
    const heightScale = defaultPageHeight / scrollHeight;
    return heightScale < defaultWidthScale ? heightScale : defaultWidthScale;
  }

  ngOnInit(): void {
        
        // wire up the logos
        this.logosData$ = this.logoService.logos$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){                  
              if(responsedata.loading){
                this.pushLoading();
              } else {
                this.logosData = responsedata["data"];      
                this.popLoding();
              }          
            }
          }
        )
        this.logoService.loadLogos();

    // Subscribe to themes and get them
        this.themeService.themes$.subscribe(data => {
          this.themes = data;
        })
        this.themeService.getThemes();
    
        this.themeSub$ = this.themeService.getSelectedTheme().subscribe(x => {
          console.log("set theme"+ JSON.stringify(x))
          if (x["value"] == "dxc-purple-theme") {
            this.themeMode = "light";
          }
          if (x["value"] == "dxc-blue-dark-theme") {
            this.themeMode = "dark";
          }
        });


      let qs = this.activatedRoute.snapshot.queryParamMap
      console.log(JSON.stringify(qs));

      this.useNewLayout = qs['params']['layout'] === 'new';

    // wire up the accounts and load them
    this.accountsData$ = this.accountService.accounts$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){                  
          this.accountsData = responsedata;
        
          this.accountsData["data"].forEach(x => {
            if(x["id"]==qs["params"]["a"]) {
              this.sAccount = x;
              this.sVersion = qs["params"]["v"]

              // now load the other things
              this.loadAccountData();
              this.isData = true;
            }
          })

        }
      }
    );
    this.accountService.loadAccounts();          

        // wire up the account status values
        this.accountsStatusData$ = this.acountsStatusService.accountsStatus$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){                  
              if(responsedata.loading){
                this.pushLoading();
              } else {
                this.accountsStatusData = responsedata["data"];
                // turn the array returned into an object            
                this.accountsStatusData = {};
                responsedata["data"].forEach(x => {
                  this.accountsStatusData[x["propertyname"]] = x;
                });            
                this.popLoding();
              }          
            }
          }
        );

            // wire up the entities
    this.entitiesData$ = this.entityService.entities$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){                  
          if(responsedata.loading){
             this.pushLoading();
          } else {
            this.entitiesData = responsedata["data"];            

             // add the client logo to each of the entities
            // so the entity can use the client logo if there is one
            this.entitiesData.forEach(x => {
              x["clientlogo"] = this.sAccount["logo"];
              addEntityProperty(x);
            });
            this.popLoding();
          }          
        }
      }
    );

            // wire up the asset Map values
            this.assetMapsData$ = this.assetMapService.assetMap$.subscribe(
              (responsedata: any) => {
                if(responsedata!=null){                  
                  if(responsedata.loading){
                     this.pushLoading();
                  
                  } else {
                    // turn the array returned into an object
                    // also see if the data has any total estate vals
                    // if it does then we should both values on the page
                    // for all of the values
    
                    this.assetMapData = {};    
                    responsedata["data"].forEach(x => {
                      this.assetMapData[x["propertyname"]] = x;                                                            
                    });            
                    this.popLoding();
                  }          
                }
              }
            );

      this.stackColors$ = this.entityService.stackColors$.subscribe((res: any) => {
        if (res) {
          if (res.loading) {
            this.pushLoading();
          } else {
            if (Array.isArray(res.data) && res.data.length) {
              this.stackColors = res.data;
            }
            this.popLoding();
          }
        }
      });
  }

  loadAccountData(){
    // load the data
    if(this.sAccount){
      this.entityService.loadEntities(this.sAccount["id"],this.sVersion);
      this.acountsStatusService.loadStatus(this.sAccount["id"],this.sVersion);
      this.assetMapService.loadAssetMap(this.sAccount["id"],this.sVersion);
      this.entityService.loadStackColors();
    }
}
pushLoading(){    
  this.loading++;
  // console.log("push:"+this.loading)
  this.isLoading = true;
}

popLoding(){
  this.loading--;
  // console.log("pop:"+this.loading)
  if(this.loading<=0){
    this.loading=0;
    this.isLoading = false;
  }
}



getLogo(account:Object){
  if(account==undefined || account==null) return "";
  let rtn = "";
  this.logosData.forEach(x => {      
    if(x.name==account["logo"]) {
      rtn = x.file
    }   
  });
  return rtn;
}


}
